export interface Purchase {
  name: string
  location: string
  minutesAgo: number
}

export const purchases: Purchase[] = [
  { name: 'Emma L.', location: 'Portland, USA', minutesAgo: 2 },
  { name: 'Sophie R.', location: 'Bristol, United Kingdom', minutesAgo: 6 },
  { name: 'Megan T.', location: 'Vancouver, Canada', minutesAgo: 9 },
  { name: 'Claire O.', location: 'Dublin, Ireland', minutesAgo: 13 },
  { name: 'Jessica P.', location: 'Brisbane, Australia', minutesAgo: 17 },
  { name: 'Laura B.', location: 'Denver, USA', minutesAgo: 21 },
  { name: 'Rachel W.', location: 'Edinburgh, United Kingdom', minutesAgo: 26 },
  { name: 'Nicole H.', location: 'Toronto, Canada', minutesAgo: 31 },
  { name: 'Katie M.', location: 'Auckland, New Zealand', minutesAgo: 35 },
  { name: 'Daniel S.', location: 'Austin, USA', minutesAgo: 42 },
  { name: 'Amy C.', location: 'Manchester, United Kingdom', minutesAgo: 48 },
  { name: 'Olivia F.', location: 'Melbourne, Australia', minutesAgo: 54 },
]
